import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { IconX } from '@tabler/icons';
import { propTypes, defaultProps } from './CloseTimer.types.js';
import SvgCancelcircle from './cancelcircle.svg.js';
import styles from './CloseTimer.module.scss.js';

var CloseTimer = /** @class */ (function (_super) {
    __extends(CloseTimer, _super);
    function CloseTimer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            color: props.color,
        };
        return _this;
    }
    CloseTimer.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, duration = _a.duration, onClick = _a.onClick, isToast = _a.isToast;
        this.timeoutId = window.setTimeout(function () {
            onClick();
            if (isToast) {
                _this.setState({ color: 'none' });
            }
        }, duration);
    };
    CloseTimer.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.timeoutId);
    };
    CloseTimer.prototype.render = function () {
        var _a = this.props, color = _a.color, onClick = _a.onClick, duration = _a.duration, disabled = _a.disabled, isToast = _a.isToast;
        var animationColor = isToast ? this.state.color : color;
        return (React__default.createElement("button", { "data-testid": "close-timer-btn", onClick: onClick, className: "\n                    " + styles.CloseTimer + "\n                    " + (disabled ? styles.CloseTimer___disabled : '') + "\n                ", title: isToast ? 'CloseIcon' : 'CancelCircleIcon' },
            isToast ? (React__default.createElement(IconX, { size: 16, color: color, className: styles.CloseTimer_icon })) : (React__default.createElement(SvgCancelcircle, { width: 16, height: 16, color: color, className: styles.CloseTimer_icon })),
            React__default.createElement("svg", { className: styles.CloseTimer_circleWrapper },
                React__default.createElement("circle", { className: styles.CloseTimer_circle, r: "11", cx: "50%", cy: "50%", stroke: animationColor, style: { animationDuration: duration / 1000 + "s" } }))));
    };
    CloseTimer.displayName = 'CloseTimer';
    CloseTimer.propTypes = propTypes;
    CloseTimer.defaultProps = __assign({}, defaultProps);
    return CloseTimer;
}(React__default.Component));

export { CloseTimer, CloseTimer as default };
